export function thresholdCheck(threshold, ideal, value) {
  return ((value + threshold) >= ideal) && (ideal >= (value - threshold));
}
